import { fetchResponse } from './api-helper';

const userInfoUrl = `${process.env.REACT_APP_SPN_USER_API}/me`;

export const getUserInfo = () => fetchResponse(userInfoUrl);
